var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.t(interpolate( gettext("Доступ к данному почтовому сервису может быть ограничен на территории вашей страны.%(new_line)sРекомендуем изменить email в личном кабинете."), {'new_line': '<br>'} , true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{{ ___0___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/login_domain_disabled.html
// module id = 200
// module chunks = 4